import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MapPinIcon, StarIcon } from 'lucide-react';
import { sellerFor } from '../../data/market';
import { naira } from '../../utils/format';
import type { MarketItem } from '../../types/market';

/**
 * The compact rail listing. Thumbnail, name, who is selling it, one piece of
 * category-appropriate context, then price — in that order, because price is
 * what the eye is scanning for.
 */
export function MiniListing({
  item,
  reason
}: {
  item: MarketItem;
  reason?: string;
}) {
  const seller = sellerFor(item.sellerId);
  const context = item.deliveryLabel && item.prepMinutes ? `${item.prepMinutes}–${item.prepMinutes + 10} min` : item.distanceKm !== undefined ? `${item.distanceKm} km away` : item.courseCodes?.length ? item.courseCodes.join(', ') : undefined;
  return <li data-id="element-3005" data-mp="2n2v2579sbryz">
      <Link to={`/market/item/${item.id}`} className="flex gap-3 rounded-card px-2 py-2 transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-3006" data-mp="2n3d3ujf7uyea">
        <span className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-canvas" data-id="element-3007" data-mp="3mtdnytgm33py">
          {item.imageUrl ? <img src={item.imageUrl} alt="" loading="lazy" className="h-full w-full object-cover" data-id="element-3008" data-mp="o0bpsr49v93" /> : <span className="flex h-full w-full items-center justify-center text-body-lg font-semibold text-ink-subtle" data-id="element-3009" data-mp="5gjoinhzcmcu">
              {item.title.charAt(0)}
            </span>}
        </span>

        <span className="min-w-0 flex-1" data-id="element-3010" data-mp="eh83bkf76qqs">
          <span className="block truncate text-body-sm font-semibold text-ink" data-id="element-3011" data-mp="jfjcdsxo4x7y">{item.title}</span>
          <span className="mt-0.5 block truncate text-caption text-ink-muted" data-id="element-3012" data-mp="odujhvwkwtmh">
            {reason ?? seller?.displayName}
          </span>

          <span className="mt-1 flex flex-wrap items-center gap-x-2.5 gap-y-1" data-id="element-3013" data-mp="2l7xrylcqppl7">
            {item.rating !== undefined && <span className="cz-num inline-flex items-center gap-1 text-caption text-ink-muted" data-id="element-3014" data-mp="2i49psf2giw9c">
                <StarIcon aria-hidden className="h-3.5 w-3.5 fill-warn-700 text-warn-700" data-id="element-3015" data-mp="2d5f0cu9zi9g9" />
                {item.rating.toFixed(1)}
              </span>}
            {context && <span className="cz-num inline-flex items-center gap-1 text-caption text-ink-subtle" data-id="element-3016" data-mp="2n3cpdjzo4a9x">
                {item.distanceKm !== undefined ? <MapPinIcon aria-hidden className="h-3.5 w-3.5" data-id="element-3017" data-mp="311jdw9iq8xwx" /> : item.prepMinutes ? <ClockIcon aria-hidden className="h-3.5 w-3.5" data-id="element-3018" data-mp="2w3raojcmtpdf" /> : null}
                {context}
              </span>}
          </span>

          <span className="cz-num mt-1 block text-body-sm font-semibold text-ink" data-id="element-3019" data-mp="35tkozs45sild">
            {item.priceNaira === undefined ? 'Quoted per job' : naira(item.priceNaira)}
            {item.priceNaira !== undefined && item.priceUnit && item.priceUnit !== 'each' && <span className="font-normal text-ink-muted" data-id="element-3020" data-mp="2aws8ibny6k2"> / {item.priceUnit.replace('per ', '')}</span>}
          </span>
        </span>
      </Link>
    </li>;
}